import React from 'react';
import { css } from 'styled-components';
import { ColorBrandBlue1, ColorNeutralGrey3, FontWeightNormal } from 'autogen/design-tokens/tokens';
import Button from './Button';
import ButtonWithIcon from './ButtonWithIcon';
import type IButton from './shared/types/button';
import type IButtonWithIcon from './shared/types/buttonWithIcon';

const styles = css<{ isActive?: boolean }>`
    border-color: ${({ isActive }) => (isActive ? ColorBrandBlue1 : ColorNeutralGrey3)};
    border-width: ${({ isActive }) => (isActive ? '2px' : '1px')};
    font-weight: ${FontWeightNormal};
    border-style: solid;
    background-color: white;
    white-space: nowrap;
`;

type ButtonWithActiveStateProps = {
    isActive?: boolean;
};

export type DefaultProps = ButtonWithActiveStateProps & IButton;
export type WithIconProps = ButtonWithActiveStateProps & IButtonWithIcon;

const ButtonWithActiveState = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, DefaultProps>((props, ref) => (
    <Button css={styles} ref={ref} variant="outline" {...props} />
));

const ButtonWithActiveStateWithIcon = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, WithIconProps>(
    (props, ref) => <ButtonWithIcon css={styles} ref={ref} variant="outline" {...props} />
);

export default Object.assign(ButtonWithActiveState, {
    WithIcon: ButtonWithActiveStateWithIcon
});
